import { Component } from '@angular/core';
import { ClientsModule } from '../../../../clients/clients.module';
import { LayoutModule } from '../../../layout/layout.module';

@Component({
  selector: 'app-client-view-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    ClientsModule,
  ],
  templateUrl: './client-view-dashboard-page.component.html',
  styleUrl: './client-view-dashboard-page.component.sass',
})
export class ClientViewDashboardPageComponent {

}
